import type {WorkspaceAction, WorkspaceState} from './types';
import type {SyncResult} from '../types';
import {upsertKnowledgeRecord, mergeTicketRecords} from '../services/workspaceRecords';

export function initialWorkspaceState(): WorkspaceState {
  return {tickets: [], docs: [], gmail: null, aiSettings: null, loading: true, error: '',
    newOpen: false, selected: null, generating: {}, modelSaving: false};
}

function applySync(state: WorkspaceState, result: SyncResult): WorkspaceState {
  return {...state, tickets: mergeTicketRecords(state.tickets, result.tickets),
    gmail: state.gmail ? {...state.gmail, last_sync: result.last_sync, error: result.warning} : null};
}

function finishGeneration(state: WorkspaceState, id: string): WorkspaceState {
  const generating = {...state.generating}; delete generating[id];
  return {...state, generating};
}

export function workspaceReducer(state: WorkspaceState, action: WorkspaceAction): WorkspaceState {
  switch (action.type) {
    case 'patch': return {...state, ...action.value};
    case 'ticket-saved': return {...state, tickets: mergeTicketRecords(state.tickets, [action.ticket])};
    case 'knowledge-saved': return {...state, docs: upsertKnowledgeRecord(state.docs, action.document)};
    case 'knowledge-removed': return {...state, docs: state.docs.filter(document => document.id !== action.id)};
    case 'inbox-refreshed': return {...state, tickets: mergeTicketRecords(state.tickets, action.tickets), gmail: action.gmail};
    case 'gmail-synced': return applySync(state, action.result);
    case 'generation-progress': return {...state, generating: {...state.generating, [action.id]: action.stage}};
    case 'generation-finished': return finishGeneration(state, action.id);
  }
}